export function extractIsoTimeHHMM(iso: string): string | null {
  const m = /^[0-9]{4}-[0-9]{2}-[0-9]{2}T([0-9]{2}:[0-9]{2})/.exec(iso);
  return m ? m[1] : null;
}

export function formatTimeHHMM(iso: string): string {
  const extracted = extractIsoTimeHHMM(iso);
  if (extracted) return extracted;

  const d = new Date(iso);
  return d.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatTimeRange(startAt: string, endAt: string): string {
  return `${formatTimeHHMM(startAt)}–${formatTimeHHMM(endAt)}`;
}

const RU_WEEKDAYS_SHORT: readonly string[] = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];

export function formatWeekdayDateShortRu(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';

  const weekday = RU_WEEKDAYS_SHORT[date.getDay()] ?? '';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${weekday}, ${day}.${month}`;
}
